import React from 'react';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-section">
        <h4>Liên hệ hỗ trợ kỹ thuật</h4>
        <ul style={{lineHeight: "2.1", marginLeft: 25}}>
          <li>
            <span role="img" aria-label="email" style={{marginRight: 8}}>📧</span>
            Email: <a href="mailto:tino@tinovation.io.vn">tino@tinovation.io.vn</a>
          </li>
          <li>
            <span role="img" aria-label="hotline" style={{marginRight: 8}}>📞</span>
            Hotline: <a href="tel:0827277157">0827277157</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      © {new Date().getFullYear()} Tinovation. All rights reserved.
    </div>
  </footer>
);

export default Footer;